export function propsToInitialState(data) {
  const dataInit = { ...data };
  dataInit.linhVuc = null;
  dataInit.app = null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.appId = value?.appId || value?.app?.id || 0;
  return dataSave;
}
